import React from 'react'

// apollo
import { ApolloProvider } from '@apollo/client'
import { client } from 'lib/apollo'

// redux
import { Provider as ReduxProvider } from 'react-redux'
import store from 'lib/stores/online/redux'

// themes
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import unoTheme from 'lib/themes/unoTheme'
import kidTheme from 'lib/themes/kidTheme'

// shared components
import AppErrorBoundary from 'components/shared/AppErrorBoundary'
import SettingsProvider from 'components/shared/SettingsProvider'

// local components
import Routes from './Routes'

// date picker
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

const App = ({ basename, appSettings, brandSettings }) => (
  <SettingsProvider appSettings={appSettings} brandSettings={brandSettings}>
    <ReduxProvider store={store}>
      <ApolloProvider client={client}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <ThemeProvider theme={unoTheme}>
            <CssBaseline />
            <ThemeProvider theme={kidTheme}>
              <AppErrorBoundary>
                <Routes basename={basename} />
              </AppErrorBoundary>
            </ThemeProvider>
          </ThemeProvider>
        </LocalizationProvider>
      </ApolloProvider>
    </ReduxProvider>
  </SettingsProvider>
)

export default App
